import { useTranslation } from "@/hooks/useTranslation"
import { InformationAlert } from "@/molecules/InformationAlert"

import styles from "./AlertConfigurationTabVirtualMachineDrawer.module.scss"

import type { AlertConfigurationTabVirtualMachineDrawerProps } from "./AlertConfigurationTabVirtualMachineDrawer.types"

export const AlertConfigurationTabVirtualMachineDrawer = (
  props: AlertConfigurationTabVirtualMachineDrawerProps
) => {
  const { t } = useTranslation()
  const {
    type,
    tKey = "",
    message = t(tKey),
    palette = !type ? "info" : undefined
  } = props

  return (
    <InformationAlert
      type={type}
      palette={palette}
      message={message}
      className={styles.alert}
    />
  )
}
